exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-handcrafted-js": () => import("./../../../src/pages/handcrafted.js" /* webpackChunkName: "component---src-pages-handcrafted-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-website-design-st-thomas-js": () => import("./../../../src/pages/website-design-st-thomas.js" /* webpackChunkName: "component---src-pages-website-design-st-thomas-js" */)
}

